import React from 'react';
import ReactDOM from 'react-dom';
import CSSX from 'react-cssx';
// import CSSX from '../../../lib/CSSX.js';
// import CSSX from '../../../src/CSSX.jsx';

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      color: '#000'
    };
  }
  render() {
    return <CSSX styles={this.css()}>
        <h1>Title styled with <i>CSSX</i></h1>
        <input defaultValue="#000" type="text" onChange={this._change.bind(this)} />
      </CSSX>;
  }
  css() {
    return (function () {
      var _2 = {},
          _3 = {},
          _4 = {},
          _5 = {},
          _6 = {};
      _3['color'] = this.state.color;
      _4['text-decoration'] = 'underline';
      _5['color'] = 'red';
      _6['h1'] = _5;
      _2['h1'] = _3;
      _2['h1 i'] = _4;
      _2['@media (max-width: 600px)'] = _6;
      return _2;
    }.apply(this));
  }
  _change(e) {
    this.setState({ color: e.target.value });
  }
}

class Replacement extends React.Component {
  render() {
    return <p>Something else</p>;
  }
}

var content = document.querySelector('#content');
var button = document.querySelector('button');

ReactDOM.render(<Component />, content);
button.addEventListener('click', function () {
  ReactDOM.render(<Replacement />, content);
});


/** WEBPACK FOOTER **
 ** ./src/app.jsx
 **/